import { CouponType } from '../interfaces';
export const getDiscountDescription = function (coupon, t, isBM, currency, isOverview) {
  var _coupon$couponMetadat, _coupon$couponMetadat2;
  if (isBM === void 0) {
    isBM = true;
  }
  if (currency === void 0) {
    currency = '$';
  }
  if (isOverview === void 0) {
    isOverview = false;
  }
  const prefix = isBM ? 'promos_bm' : 'promotions.widget';
  const couponDiscountType = coupon.couponDiscountType;
  const isMinOrder = coupon.isCoupon && ((_coupon$couponMetadat = coupon.couponMetadata) == null || (_coupon$couponMetadat = _coupon$couponMetadat.couponToEdit) == null || (_coupon$couponMetadat = _coupon$couponMetadat.specification) == null ? void 0 : _coupon$couponMetadat.minimumSubtotal);
  const isItem = !!((_coupon$couponMetadat2 = coupon.couponMetadata) != null && _coupon$couponMetadat2.name);
  const getItemName = () => {
    var _coupon$couponMetadat3;
    return isItem ? ((_coupon$couponMetadat3 = coupon.couponMetadata) == null ? void 0 : _coupon$couponMetadat3.name) || '' : t(`${prefix}.offer.description.all_products`);
  };
  const getCouponMessage = (metric, amount) => t(`${prefix}.offer.description.${isOverview ? 'coupon_message_overview' : 'coupon_message'}`, {
    amount,
    metric,
    itemName: getItemName()
  });
  const getMinimumOrderMessage = () => {
    if (couponDiscountType === CouponType.MoneyOff) {
      var _coupon$couponMetadat4, _coupon$couponMetadat5;
      return t(`${prefix}.offer.description.minimum_order.money_off`, {
        amount: (_coupon$couponMetadat4 = coupon.couponMetadata) == null ? void 0 : _coupon$couponMetadat4.moneyOffAmount,
        currency,
        min_offer_amount: (_coupon$couponMetadat5 = coupon.couponMetadata) == null || (_coupon$couponMetadat5 = _coupon$couponMetadat5.couponToEdit) == null || (_coupon$couponMetadat5 = _coupon$couponMetadat5.specification) == null ? void 0 : _coupon$couponMetadat5.minimumSubtotal
      });
    } else if (couponDiscountType === CouponType.PercentOff) {
      var _coupon$couponMetadat6, _coupon$couponMetadat7;
      return t(`${prefix}.offer.description.minimum_order.percent_off`, {
        amount: (_coupon$couponMetadat6 = coupon.couponMetadata) == null ? void 0 : _coupon$couponMetadat6.percentOffRate,
        metric: '%',
        currency,
        min_offer_amount: (_coupon$couponMetadat7 = coupon.couponMetadata) == null || (_coupon$couponMetadat7 = _coupon$couponMetadat7.couponToEdit) == null || (_coupon$couponMetadat7 = _coupon$couponMetadat7.specification) == null ? void 0 : _coupon$couponMetadat7.minimumSubtotal
      });
    } else if (couponDiscountType === CouponType.FreeShipping) {
      var _coupon$couponMetadat8;
      return t(`${prefix}.offer.description.minimum_order.free_shipping`, {
        currency,
        min_offer_amount: (_coupon$couponMetadat8 = coupon.couponMetadata) == null || (_coupon$couponMetadat8 = _coupon$couponMetadat8.couponToEdit) == null || (_coupon$couponMetadat8 = _coupon$couponMetadat8.specification) == null ? void 0 : _coupon$couponMetadat8.minimumSubtotal
      });
    }
    return '';
  };
  const couponTypeMap = {
    [CouponType.MoneyOff]: () => {
      var _coupon$couponMetadat9;
      return getCouponMessage(currency, (_coupon$couponMetadat9 = coupon.couponMetadata) == null ? void 0 : _coupon$couponMetadat9.moneyOffAmount);
    },
    [CouponType.BuyXGetY]: () => {
      var _coupon$couponMetadat0, _coupon$couponMetadat1;
      return t(`${prefix}.offer.description.${isOverview ? 'coupon_message_x_y_overview' : 'coupon_message_x_y'}`, {
        x: (_coupon$couponMetadat0 = coupon.couponMetadata) == null || (_coupon$couponMetadat0 = _coupon$couponMetadat0.buyXGetY) == null ? void 0 : _coupon$couponMetadat0.x,
        y: (_coupon$couponMetadat1 = coupon.couponMetadata) == null || (_coupon$couponMetadat1 = _coupon$couponMetadat1.buyXGetY) == null ? void 0 : _coupon$couponMetadat1.y,
        itemName: getItemName()
      });
    },
    [CouponType.FixedPrice]: () => {
      var _coupon$couponMetadat10;
      return getCouponMessage(currency, (_coupon$couponMetadat10 = coupon.couponMetadata) == null ? void 0 : _coupon$couponMetadat10.fixedPriceAmount);
    },
    [CouponType.PercentOff]: () => {
      var _coupon$couponMetadat11;
      return getCouponMessage('%', (_coupon$couponMetadat11 = coupon.couponMetadata) == null ? void 0 : _coupon$couponMetadat11.percentOffRate);
    },
    [CouponType.FreeShipping]: () => t(`${prefix}.offer.description.free_shipping`),
    MINIMUM_ORDER: () => getMinimumOrderMessage()
  };
  return couponTypeMap[couponDiscountType] ? couponTypeMap[isMinOrder ? 'MINIMUM_ORDER' : couponDiscountType]() : '';
};
//# sourceMappingURL=getDiscountDescription.js.map